<div class="cr02-catalog container-fluid width-box">
  <div class="crumb"><a routerLink="/admin/manageuser">Admin</a> / Master Catalog</div>

  <div class="page-head">
    <h1>Master Catalog</h1>
    <ng-container *ngIf="activeMenu === 'items'">
      <button type="button" class="btn btn-ghost" [disabled]="masterSyncInProgress" (click)="syncMasterRecent()">
        <i-feather name="rotate-cw"></i-feather> Sync recent
      </button>
      <button type="button" class="btn btn-primary" [disabled]="masterSyncInProgress" (click)="syncMasterFull()">
        <i-feather name="upload"></i-feather> Full sync
      </button>
    </ng-container>
    <ng-container *ngIf="activeMenu === 'suppliers'">
      <button type="button" class="btn btn-primary" [disabled]="supplierSyncInProgress" (click)="syncMasterSuppliers()">
        <i-feather name="rotate-cw"></i-feather> Sync suppliers
      </button>
    </ng-container>
    <span class="sub">Browse master items, barcodes, and vendors — or sync suppliers from the ERP master.</span>
  </div>

  <div class="card">
    <div class="tabs">
      <button type="button" class="tab" [class.active]="activeMenu === 'items'" (click)="setActiveMenu('items')">
        Items
        <span class="count">{{ distinctItemCount | number }}</span>
      </button>
      <button type="button" class="tab" [class.active]="activeMenu === 'suppliers'" (click)="setActiveMenu('suppliers')">
        Suppliers
        <span class="count">{{ supplierTotal | number }}</span>
      </button>
    </div>

    <!-- Items -->
    <ng-container *ngIf="activeMenu === 'items'">
      <div class="sync-panel" *ngIf="syncPanelVisible">
        <div class="sync-head">
          <div class="sync-title">
            <strong>Master sync</strong>
            <span class="chip" *ngIf="syncJob?.sync_mode">{{ syncJob.sync_mode }}</span>
            <span class="badge" [ngClass]="syncStatusBadgeClass()">{{ syncStatusLabel() }}</span>
          </div>
          <div class="sync-actions">
            <button
              type="button"
              class="btn btn-sm btn-danger-outline"
              *ngIf="masterSyncInProgress"
              [disabled]="masterSyncStopRequested"
              (click)="stopMasterSync()">
              <i-feather name="x-circle"></i-feather>
              {{ masterSyncStopRequested ? 'Stopping…' : 'Stop sync' }}
            </button>
            <button
              type="button"
              class="btn btn-sm btn-ghost"
              *ngIf="!masterSyncInProgress"
              (click)="dismissSyncPanel()">
              Dismiss
            </button>
          </div>
        </div>

        <div class="sync-meta" *ngIf="syncJob?.from_date && syncJob?.to_date">
          <div class="sync-stat">
            <div class="sync-stat-label">Date range</div>
            <div class="sync-stat-value">{{ syncJob.from_date }} → {{ syncJob.to_date }}</div>
          </div>
          <div class="sync-stat">
            <div class="sync-stat-label">Stage</div>
            <div class="sync-stat-value">{{ syncStageLabel() }}</div>
          </div>
        </div>

        <div class="sync-progress" *ngIf="syncJob?.progress?.total_pages">
          <div class="sync-progress-labels">
            <span>{{ syncPageProgressText() }}</span>
            <span>{{ syncPageProgressPercent() }}%</span>
          </div>
          <div class="progress-track">
            <div
              class="progress-fill"
              [class.animated]="masterSyncInProgress"
              [style.width.%]="syncPageProgressPercent()"></div>
          </div>
        </div>

        <div class="sync-counts">
          <div class="sync-stat">
            <div class="sync-stat-label">Items</div>
            <div class="sync-stat-value">{{ syncCounts().items | number }}</div>
          </div>
          <div class="sync-stat">
            <div class="sync-stat-label">Barcodes</div>
            <div class="sync-stat-value">{{ syncCounts().barcodes | number }}</div>
          </div>
          <div class="sync-stat">
            <div class="sync-stat-label">Vendors</div>
            <div class="sync-stat-value">{{ syncCounts().vendors | number }}</div>
          </div>
        </div>

        <div class="sync-msg ok" *ngIf="syncJob?.status === 'success' && syncJob?.finish_message">
          {{ syncJob.finish_message }}
        </div>
        <div class="sync-msg err" *ngIf="syncJob?.status === 'failed'">
          {{ syncJob?.error || syncJob?.finish_message || syncJob?.result?.message || 'Sync failed' }}
        </div>
        <div class="sync-msg muted" *ngIf="masterSyncInProgress && !syncJob?.progress?.total_pages">
          Waiting for sync to start…
        </div>
      </div>

      <div class="filters">
        <div class="filter-grid">
          <label class="field">
            <span>Item code</span>
            <input type="text" [(ngModel)]="filters.item_code" placeholder="Item code">
          </label>
          <label class="field">
            <span>Item name</span>
            <input type="text" [(ngModel)]="filters.item_name" placeholder="Item name">
          </label>
          <label class="field">
            <span>Barcode</span>
            <input type="text" [(ngModel)]="filters.barcode" placeholder="Barcode">
          </label>
          <label class="field">
            <span>Vendor code</span>
            <input type="text" [(ngModel)]="filters.vendor_code" placeholder="Vendor code">
          </label>
          <label class="field">
            <span>Supplier name</span>
            <select [(ngModel)]="filters.vendor_name">
              <option value="">All suppliers</option>
              <option *ngFor="let name of supplierNames" [value]="name">{{ name }}</option>
            </select>
          </label>
          <label class="field">
            <span>Vendor item code</span>
            <input type="text" [(ngModel)]="filters.vendor_item_code" placeholder="Vendor SKU">
          </label>
        </div>
        <div class="filter-actions">
          <button type="button" class="btn btn-ghost btn-sm" (click)="clearFilters()">
            <i-feather name="x"></i-feather> Clear
          </button>
          <button type="button" class="btn btn-ghost btn-sm" (click)="loadCatalog(0)">
            <i-feather name="rotate-cw"></i-feather> Refresh
          </button>
          <button type="button" class="btn btn-primary btn-sm" (click)="applyFilters()">
            <i-feather name="filter"></i-feather> Apply filters
          </button>
        </div>
      </div>

      <div class="table-meta">
        <span class="chip chip-brand">{{ distinctItemCount | number }} item(s)</span>
        <span class="chip">{{ totalrec | number }} row(s)</span>
      </div>

      <div class="table-wrap" *ngIf="totalrec; else itemsEmpty">
        <table>
          <thead>
            <tr>
              <th>#</th>
              <th>Item code</th>
              <th>Item name</th>
              <th>Item status</th>
              <th>Barcode</th>
              <th>Trans UOM</th>
              <th>Stock UOM</th>
              <th>Conversion</th>
              <th>Barcode status</th>
              <th>Vendor code</th>
              <th>Vendor name</th>
              <th>Vendor item code</th>
              <th>Vendor UOM</th>
              <th>Tax %</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of rows; let i = index">
              <td class="num">{{ (currentPage - 1) * itemsPerPage + i + 1 }}</td>
              <td><strong>{{ displayValue(row.item_code) }}</strong></td>
              <td>{{ displayValue(row.item_name) }}</td>
              <td>
                <span class="badge" [ngClass]="statusBadgeClass(row.item_status)">{{ displayValue(row.item_status) }}</span>
              </td>
              <td>{{ displayValue(row.barcode) }}</td>
              <td>{{ displayValue(row.trans_uom) }}</td>
              <td>{{ displayValue(row.stock_uom) }}</td>
              <td>{{ displayValue(row.barcode_conversion) }}</td>
              <td>
                <span class="badge" [ngClass]="statusBadgeClass(row.barcode_status)">{{ displayValue(row.barcode_status) }}</span>
              </td>
              <td>{{ displayValue(row.vendor_code) }}</td>
              <td>{{ displayValue(row.vendor_name) }}</td>
              <td>{{ displayValue(row.vendor_item_code) }}</td>
              <td>{{ displayValue(row.vendor_uom) }}</td>
              <td class="num">{{ displayValue(row.tax_perc) }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="table-foot" *ngIf="totalrec > 0">
        <span class="range">{{ itemsRangeLabel }}</span>
        <label class="rows-per">
          Rows per page
          <select [ngModel]="itemsPerPage" (ngModelChange)="onRowsPerChange($event)">
            <option *ngFor="let n of rowsPerOptions" [ngValue]="n">{{ n }}</option>
          </select>
        </label>
        <nav class="pager" aria-label="Catalog pagination">
          <button type="button" class="pg" [disabled]="currentPage <= 1" (click)="prevPage()" aria-label="Previous page">‹</button>
          <ng-container *ngFor="let item of itemsPagerItems">
            <span class="pg gap" *ngIf="item === '…'">…</span>
            <button
              type="button"
              class="pg"
              *ngIf="item !== '…'"
              [class.current]="item === currentPage"
              (click)="goToItemsPage(item)">
              {{ item }}
            </button>
          </ng-container>
          <button type="button" class="pg" [disabled]="num_of_pages > 0 && currentPage >= num_of_pages" (click)="nextPage()" aria-label="Next page">›</button>
        </nav>
        <div class="goto">
          <span>Go to page</span>
          <input
            type="number"
            min="1"
            [max]="num_of_pages || 1"
            inputmode="numeric"
            aria-label="Page number"
            [placeholder]="itemsGotoPlaceholder"
            [(ngModel)]="gotoInput"
            (keydown)="onItemsGotoKeydown($event)">
          <button type="button" (click)="submitItemsGotoPage()">Go</button>
          <span class="err" [class.show]="gotoError">Invalid page</span>
        </div>
      </div>
    </ng-container>

    <!-- Suppliers -->
    <ng-container *ngIf="activeMenu === 'suppliers'">
      <div class="sync-panel" *ngIf="supplierSyncPanelVisible">
        <div class="sync-head">
          <div class="sync-title">
            <strong>Supplier sync</strong>
            <span class="chip" *ngIf="supplierSyncJob?.sync_mode">{{ supplierSyncJob.sync_mode }}</span>
            <span class="badge" [ngClass]="supplierSyncStatusBadgeClass()">{{ supplierSyncStatusLabel() }}</span>
          </div>
          <div class="sync-actions">
            <button
              type="button"
              class="btn btn-sm btn-danger-outline"
              *ngIf="supplierSyncInProgress"
              [disabled]="supplierSyncStopRequested"
              (click)="stopSupplierSync()">
              <i-feather name="x-circle"></i-feather>
              {{ supplierSyncStopRequested ? 'Stopping…' : 'Stop sync' }}
            </button>
            <button
              type="button"
              class="btn btn-sm btn-ghost"
              *ngIf="!supplierSyncInProgress"
              (click)="dismissSupplierSyncPanel()">
              Dismiss
            </button>
          </div>
        </div>

        <div class="sync-meta">
          <div class="sync-stat">
            <div class="sync-stat-label">Stage</div>
            <div class="sync-stat-value">{{ supplierSyncStageLabel() }}</div>
          </div>
        </div>

        <div class="sync-counts">
          <div class="sync-stat">
            <div class="sync-stat-label">Suppliers processed</div>
            <div class="sync-stat-value">{{ supplierSyncCounts().suppliers | number }}</div>
          </div>
          <div class="sync-stat">
            <div class="sync-stat-label">API batches</div>
            <div class="sync-stat-value">{{ supplierSyncCounts().batches | number }}</div>
          </div>
        </div>

        <div class="sync-msg ok" *ngIf="supplierSyncJob?.status === 'success' && supplierSyncJob?.finish_message">
          {{ supplierSyncJob.finish_message }}
        </div>
        <div class="sync-msg err" *ngIf="supplierSyncJob?.status === 'failed'">
          {{ supplierSyncJob?.error || supplierSyncJob?.finish_message || supplierSyncJob?.result?.message || 'Sync failed' }}
        </div>
        <div class="sync-msg muted" *ngIf="supplierSyncInProgress && supplierSyncJob?.progress?.stage === 'queued'">
          Waiting for sync to start…
        </div>
      </div>

      <div class="filters">
        <div class="filter-grid">
          <label class="field">
            <span>Supplier ID</span>
            <input type="text" [(ngModel)]="supplierFilters.supplier_id" placeholder="Supplier ID">
          </label>
          <label class="field">
            <span>Supplier name</span>
            <input type="text" [(ngModel)]="supplierFilters.supplier_name" placeholder="Supplier name">
          </label>
          <label class="field">
            <span>Supplier ERP code</span>
            <input type="text" [(ngModel)]="supplierFilters.supplier_erp_code" placeholder="ERP code">
          </label>
          <label class="field">
            <span>Status</span>
            <select [(ngModel)]="supplierFilters.status">
              <option value="">All</option>
              <option value="1">Active</option>
              <option value="0">Inactive</option>
            </select>
          </label>
        </div>
        <div class="filter-actions">
          <button type="button" class="btn btn-ghost btn-sm" (click)="clearSupplierFilters()">
            <i-feather name="x"></i-feather> Clear
          </button>
          <button type="button" class="btn btn-ghost btn-sm" (click)="loadSuppliers(0)">
            <i-feather name="rotate-cw"></i-feather> Refresh
          </button>
          <button type="button" class="btn btn-primary btn-sm" (click)="applySupplierFilters()">
            <i-feather name="filter"></i-feather> Apply filters
          </button>
        </div>
      </div>

      <div class="table-meta">
        <span class="chip chip-brand">{{ supplierTotal | number }} supplier(s)</span>
      </div>

      <div class="table-wrap" *ngIf="supplierTotal; else suppliersEmpty">
        <table>
          <thead>
            <tr>
              <th>#</th>
              <th>Supplier ID</th>
              <th>Supplier name</th>
              <th>Supplier ERP code</th>
              <th>Status</th>
              <th>Created</th>
              <th>Updated</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of supplierRows; let i = index">
              <td class="num">{{ (supplierCurrentPage - 1) * itemsPerPage + i + 1 }}</td>
              <td><strong>{{ displayValue(row.supplier_id) }}</strong></td>
              <td>{{ displayValue(row.supplier_name) }}</td>
              <td>{{ displayValue(row.supplier_erp_code) }}</td>
              <td>
                <span class="badge" [ngClass]="supplierRowStatusClass(row.status)">{{ displaySupplierStatus(row.status) }}</span>
              </td>
              <td>{{ displayValue(row.createdAt) }}</td>
              <td>{{ displayValue(row.updatedAt) }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="table-foot" *ngIf="supplierTotal > 0">
        <span class="range">{{ suppliersRangeLabel }}</span>
        <label class="rows-per">
          Rows per page
          <select [ngModel]="itemsPerPage" (ngModelChange)="onRowsPerChange($event)">
            <option *ngFor="let n of rowsPerOptions" [ngValue]="n">{{ n }}</option>
          </select>
        </label>
        <nav class="pager" aria-label="Suppliers pagination">
          <button type="button" class="pg" [disabled]="supplierCurrentPage <= 1" (click)="prevSupplierPage()" aria-label="Previous page">‹</button>
          <ng-container *ngFor="let item of suppliersPagerItems">
            <span class="pg gap" *ngIf="item === '…'">…</span>
            <button
              type="button"
              class="pg"
              *ngIf="item !== '…'"
              [class.current]="item === supplierCurrentPage"
              (click)="goToSuppliersPage(item)">
              {{ item }}
            </button>
          </ng-container>
          <button type="button" class="pg" [disabled]="supplierNumPages > 0 && supplierCurrentPage >= supplierNumPages" (click)="nextSupplierPage()" aria-label="Next page">›</button>
        </nav>
        <div class="goto">
          <span>Go to page</span>
          <input
            type="number"
            min="1"
            [max]="supplierNumPages || 1"
            inputmode="numeric"
            aria-label="Page number"
            [placeholder]="suppliersGotoPlaceholder"
            [(ngModel)]="supplierGotoInput"
            (keydown)="onSuppliersGotoKeydown($event)">
          <button type="button" (click)="submitSuppliersGotoPage()">Go</button>
          <span class="err" [class.show]="supplierGotoError">Invalid page</span>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<ng-template #itemsEmpty>
  <div class="empty-state">
    <div class="empty-title">No master catalog rows found</div>
    <div class="empty-help">Try changing or clearing the filters.</div>
  </div>
</ng-template>

<ng-template #suppliersEmpty>
  <div class="empty-state">
    <div class="empty-title">No master suppliers found</div>
    <div class="empty-help">Run sync or change the filters.</div>
  </div>
</ng-template>
